import React from "react";
import Layout from "./Layout";
import BuyMeACoffee from "./BuyMeACoffee";
import {
    CardContent,
    Button, Card,
    Paper, Slide,
    Typography, CardActions
} from "@mui/material";
import {GitHub, Archive} from "@mui/icons-material";
import { Icon } from '@iconify/react';
import Footer from "./Footer";

const Projects = () => {
    // const statsHeads = [
    //     'Website', 'Rank', 'Username', 'Profile'
    // ];
    //
    // const textColor = '#ffffff';
    //
    // const statsData = [
    //     {
    //         'site': 'HackTheBox',
    //         'rank': 'Hacker',
    //         'username': 'tombstoneGhost',
    //         'href': 'https://app.hackthebox.eu/profile/276640'
    //     },
    //     {
    //         'site': 'Vulnhub',
    //         'rank': '25+',
    //         'username': 'tombstoneGhost',
    //         'href': 'https://www.vulnhub.com/author/tombstoneghost-simardeep-singh,803/'
    //     },
    //     {
    //         'site': 'TryHackMe',
    //         'rank': 'Level 11',
    //         'username': 'tombstoneGhost',
    //         'href': 'https://tryhackme.com/p/tombstoneGhost'
    //     },
    //     {
    //         'site': 'Port Swigger Labs',
    //         'rank': 'NewBie (97/197)',
    //         'username': 'Simardeep Singh',
    //     },
    //     {
    //         'site': 'CTFLearn',
    //         'rank': '471th',
    //         'username': 'tombstone_ghost',
    //         'href': 'https://ctflearn.com/user/tombstone_ghost'
    //     },
    //     {
    //         'site': 'HackerRank',
    //         'rank': '5 Stars',
    //         'username': 'tombstone_ghost',
    //         'href': 'https://www.hackerrank.com/tombstone_ghost?hr_r=1'
    //     },
    // ];

    const securityProjectsData = [
        {
            'title': 'TIWAP',
            'description': 'A Totally Insecure Web Application Project which allows a user to perform various ' +
                'attacks on the given target. It is a replication of DVWA with more vulnerabilities.',
            'techStack': 'Frontend: HTML + CSS\nBackend: Python + Flask\nDatabase: SQLite3 + MongoDB\n' +
                'Deployment: Docker',
            'icon': <GitHub />,
            'type': 'GitHub',
            'url': 'https://github.com/tombstoneghost/TIWAP'
        },
        {
            'title': 'PyWebValidators',
            'description': 'A package that allows to Validate Text and Files shared over Web.',
            'techStack': 'Language: Python\nLibraries: PyMagic',
            'icon': <GitHub />,
            'type': 'GitHub',
            'url': 'https://github.com/tombstoneghost/PyWebValidators'
        },
        {
            'title': 'VulnCMS',
            'description': 'This box is all about CMS as its name suggests. You need to enumerate the box, find ' +
                'the CMS, and exploit in order to gain access to other and finally get the user and root flag.',
            'techStack': 'OS: Linux',
            'icon': <Archive />,
            'type': 'VulnHub',
            'url': 'https://www.vulnhub.com/entry/vulncms-1,710/'
        },
        {
            'title': 'CXplorer',
            'description': 'An active reconnaissance tool capable of scanning for open ports, available ' +
                'directories, sub-directories and subdomains.',
            'techStack': 'Language: Go\nLibraries: GoPacket',
            'icon': <GitHub />,
            'type': 'GitHub',
            'url': 'https://github.com/SecurityKnights/CXplorer'
        },
        {
            'title': 'PassManager',
            'description': 'A Java Based Password Manager which has features like storing User\'s Credentials as ' +
                'well as generate new passwords for them based on User\'s PII.',
            'techStack': 'Language: Java\nDatabase: SQLite3\nLibraries: JDBC, Mail, Crypto',
            'icon': <GitHub />,
            'type': 'GitHub',
            'url': 'https://github.com/tombstoneghost/PassManager'
        },
        {
            'title': 'Black Hat Python',
            'description': 'A collection of tools and scripts written in Python using reference from the book ' +
                'Black Hat Python.',
            'techStack': 'Language: Python',
            'icon': <GitHub />,
            'type': 'GitHub',
            'url': 'https://github.com/tombstoneghost/Black-Hat-Python'
        }
    ];

    const developmentProjectsData = [
        {
            'title': 'Book Store',
            'description': 'An Online Book Store which is a free, reliable, user interactive and fast management ' +
                'system providing features like CRUD operations on products, purchasing a product, adding to cart, ' +
                'proceeding with a payment gateway, etc.',
            'techStack': 'Frontend: ReactJS\nBackend: Node + Express\nDatabase: MongoDB\n' +
                'Payment: Braintree',
            'icon': <GitHub />,
            'type': 'GitHub',
            'url': 'https://github.com/tombstoneghost/ecommerce-MERN'
        },
        {
            'title': 'Multi-User Blog',
            'description': 'A Multi-User Blogging Platform which supports a number of features and is also SEO ' +
                'optimized, supports social logins, separate admin/user dashboards with their own authorized ' +
                'tasks like CRUD operations on Blogs, Categories and Tags.',
            'techStack': 'Frontend: ReactJS + NextJS\nBackend: Node + Express\nDatabase: MongoDB\n' +
                'E-Mail: SendGrid\nCommenting: Disqus',
            'icon': <GitHub />,
            'type': 'GitHub',
            'url': 'https://github.com/tombstoneghost/Multiuser-SEO-Blog-MERN'
        },
        {
            'title': 'Windows Screen Recorder',
            'description': 'A basic screen recorder desktop application for windows developed using Python 3.9 ' +
                'and Tkinter. This tool supports audio recording as well and it merges the audio and video and ' +
                'provides the audio.',
            'techStack': 'Frontend: Tkinter\nBackend: Python\nLibraries: future, moviePy, PyAutoGUI, Numpy, ' +
                'OpenCV, PyAudio',
            'icon': <GitHub />,
            'type': 'GitHub',
            'url': 'https://github.com/tombstoneghost/Windows-Screen-Recorder'
        }
    ];

    // const Stats = () => {
    //     return (
    //         <div style={{marginTop: '2%'}}>
    //             <Fade in={true} style={{transitionDuration: 2000}}>
    //                 <Paper style={{backgroundColor: '#132753', color: '#ffffff', padding: '2%'}}>
    //                     <div style={{textAlign: 'left'}}>
    //                         <Typography variant="h5" component="h6">Statistics</Typography>
    //                     </div>
    //                     <div style={{marginTop: '2%'}}>
    //                         <Table>
    //                             <TableHead>
    //                                 {statsHeads.map(item => (
    //                                     <TableCell
    //                                         style={{color: textColor, fontWeight: '600', textAlign: 'center'}}>
    //                                         <Typography variant='h6' component='h6'>{item}</Typography>
    //                                     </TableCell>
    //                                 )) }
    //                             </TableHead>
    //                             <TableBody>
    //                                 {statsData.map(item => (
    //                                     <TableRow>
    //                                         <TableCell style={{color: textColor, textAlign: 'center'}}>
    //                                             {item.site}
    //                                         </TableCell>
    //                                         <TableCell style={{color: textColor, textAlign: 'center'}}>
    //                                             {item.rank}
    //                                         </TableCell>
    //                                         <TableCell style={{color: textColor, textAlign: 'center'}}>
    //                                             {item.username}
    //                                         </TableCell>
    //                                         <TableCell style={{color: textColor, textAlign: 'center'}}>
    //                                             <a href={item.href} style={{textDecoration: 'none', color: textColor}}
    //                                                 target='_blank' rel='noreferrer'>
    //                                                 <Button style={{color: textColor}}>
    //                                                     View
    //                                                 </Button>
    //                                             </a>
    //                                         </TableCell>
    //                                     </TableRow>
    //                                 ))}
    //                             </TableBody>
    //                         </Table>
    //                     </div>
    //                 </Paper>
    //             </Fade>
    //         </div>
    //     )
    // };

    const SecurityProjects = () => {
        const card_colors = ["#ff0000", "#00ff00", "#0000ff"]

        return (
            <div style={{marginTop: '2%'}}>
                <Slide direction='right' in={true} style={{transitionDuration: 1500}}>
                    <Paper style={{backgroundColor: '#2b2b2b', color: '#ffffff', padding: '2%'}}>
                        <div style={{textAlign: 'left'}}>
                            <Typography variant="h5" component="h6">Security Projects</Typography>
                        </div>
                        <div className="row" style={{marginTop: '2%', display: 'flex'}}>
                            {securityProjectsData.map((project, index )=> (
                                <div className="col-4 mb-4">
                                    <Card style={{backgroundColor: '#1a1a1a', color: 'white',
                                          borderBottom: `5px solid ${card_colors[index % 3]}`}} raise>
                                        <CardContent className="text-center">
                                            <Typography variant="h6">
                                                {project.title}
                                            </Typography>
                                            <Typography className="mt-3">
                                                {project.description}
                                            </Typography>
                                            <Typography className="text-left mt-3">
                                                Tech Stack:
                                                {project.techStack.split('\n').map(str => (
                                                    <p style={{display: 'inline'}}><br/>{str}</p>
                                                ))}
                                            </Typography>
                                        </CardContent>
                                        <CardActions className="pb-4">
                                            <a className="ml-auto mr-auto" href={project.url} rel="noreferrer"
                                               target="_blank" style={{textDecoration: 'none'}}>
                                                <Button variant="outlined" size="medium" startIcon={project.icon}
                                                        style={{color: '#ffffff', borderColor: '#ffffff'}}>
                                                    {project.type}
                                                </Button>
                                            </a>
                                        </CardActions>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    </Paper>
                </Slide>
            </div>
        )
    }

    const DevelopmentProjects = () => {
        const card_colors = ["#ff0000", "#00ff00", "#0000ff"]

        return (
            <div style={{marginTop: '2%'}}>
                <Slide direction='left' in={true} style={{transitionDuration: 1500}}>
                    <Paper style={{backgroundColor: '#2b2b2b', color: '#ffffff', padding: '2%'}}>
                        <div style={{textAlign: 'left'}}>
                            <Typography variant="h5" component="h6">Development Projects</Typography>
                        </div>
                        <div style={{marginTop: '2%'}}>
                            <div className="row" style={{margin: '2% 0%', display: 'flex'}}>
                                {developmentProjectsData.map((project, index) => (
                                    <div className="col-4 mb-4">
                                        <Card style={{backgroundColor: '#1a1a1a', color: 'white',
                                            borderBottom: `5px solid ${card_colors[index % 3]}`}} raised>
                                            <CardContent className="text-center">
                                                <Typography variant="h6">
                                                    {project.title}
                                                </Typography>
                                                <Typography className="mt-3">
                                                    {project.description}
                                                </Typography>
                                                <Typography className="text-left mt-3">
                                                    Tech Stack:
                                                    {project.techStack.split('\n').map(str => (
                                                        <p style={{display: 'inline'}}><br/>{str}</p>
                                                    ))}
                                                </Typography>
                                            </CardContent>
                                            <CardActions className="pb-4">
                                                <a className="ml-auto mr-auto" href={project.url} rel="noreferrer"
                                                   target="_blank" style={{textDecoration: 'none'}}>
                                                    <Button variant="outlined" size="medium" startIcon={project.icon}
                                                            style={{color: '#ffffff', borderColor: '#ffffff'}}>
                                                        {project.type}
                                                    </Button>
                                                </a>
                                            </CardActions>
                                        </Card>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Paper>
                </Slide>
            </div>
        )
    };

    const Technologies = () => {
        return (
            <div>
                <Paper style={{backgroundColor: '#2b2b2b', color: 'white'}}>
                    <div style={{padding: '2%'}}>
                        <Typography variant="h5">Technologies I Know</Typography>
                    </div>
                    <div style={{padding: '2%', margin: '0% 10%'}}>
                        <div className="row mb-4">
                            <div className="col text-center">
                                <Icon icon="cib:linux" style={{fontSize: '72px'}}/>
                                <Typography>Linux</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="cib:python" style={{fontSize: '72px'}}/>
                                <Typography>Python</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="cib:go" style={{fontSize: '72px'}}/>
                                <Typography>GoLang</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="cib:java" style={{fontSize: '72px'}}/>
                                <Typography>Java</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="cib:javascript" style={{fontSize: '72px'}}/>
                                <Typography>JavaScript</Typography>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col text-center">
                                <Icon icon="cib:react" style={{fontSize: '72px'}}/>
                                <Typography>ReactJS</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="raphael:nodejs" style={{fontSize: '72px'}}/>
                                <Typography>NodeJS</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="cib:flask" style={{fontSize: '72px'}}/>
                                <Typography>Flask</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="cib:mongodb" style={{fontSize: '72px'}}/>
                                <Typography>MongoDB</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="cib:mysql" style={{fontSize: '72px'}}/>
                                <Typography>SQL</Typography>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col text-center">
                                <Icon icon="cib:powershell" style={{fontSize: '72px'}}/>
                                <Typography>PowerShell</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="codicon:terminal-bash" style={{fontSize: '72px'}}/>
                                <Typography>Bash</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="ant-design:cloud-server-outlined" style={{fontSize: '72px'}}/>
                                <Typography>Cloud</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="cib:google-cloud" style={{fontSize: '72px'}}/>
                                <Typography>GCP</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="cib:amazon-aws" style={{fontSize: '72px'}}/>
                                <Typography>AWS</Typography>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col text-center">
                                <Icon icon="cib:github" style={{fontSize: '72px'}}/>
                                <Typography>GitHub</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="cib:docker" style={{fontSize: '72px'}}/>
                                <Typography>Docker</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="carbon:application-web" style={{fontSize: '72px'}}/>>
                                <Typography>BurpSuite</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="simple-icons:kalilinux" style={{fontSize: '72px'}}/>
                                <Typography>Metasploit</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="file-icons:nmap" style={{fontSize: '72px'}}/>
                                <Typography>NMap</Typography>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col text-center">
                                <Icon icon="simple-icons:wireshark" style={{fontSize: '72px'}}/>>
                                <Typography>WireShark</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="simple-icons:splunk" style={{fontSize: '72px'}}/>
                                <Typography>Splunk</Typography>
                            </div>
                            <div className="col text-center">
                                <Icon icon="file-icons:nessus" style={{fontSize: '72px'}}/>
                                <Typography>Nessus</Typography>
                            </div>
                        </div>
                    </div>
                </Paper>
            </div>
        )
    }

    const Content = () => {
        return (
            <div style={{marginTop: '8%', color: '#ffffff', marginBottom: '5%'}}>
                <div className="container-fluid">
                    <Slide direction='left' in={true} style={{transitionDuration: 2000}}>
                        <Typography variant="h3" component="h3"
                                    style={{fontWeight: 600, marginBottom: '1%', textAlign: 'center'}}>
                            My Portfolio
                        </Typography>
                    </Slide>
                </div>
                <div className="container">
                    <Technologies />
                    <SecurityProjects />
                    <DevelopmentProjects />
                    <BuyMeACoffee />
                </div>
            </div>
        )
    };

    return(
        <Layout>
            <Content />
            <Footer bgColor="#212121"/>
        </Layout>
    )
};

export default Projects;